import {
  Component,
  ElementRef,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AppConfig } from '../../app.config';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { SharedService } from '../../services/shared.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { PomodoroRepository } from '../../Models/PomodoroRepository';
import { GoftinoService } from 'src/app/services/giftino.sevice';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @ViewChild('hello', { static: false }) divHello: ElementRef<HTMLInputElement>;
  public user = {
    username: '',
    password: '',
  };
  public pomodoroRepository: PomodoroRepository;
  public error: any;
  public registerSpinner = false;
  constructor(
    private router: Router,
    private userService: UserService,
    private config: AppConfig,
    private snackBar: SnackBarService,
    private injector: Injector,
    private goftinoService: GoftinoService
  ) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    this.activate();
  }
  activate(): any {
    // this.checkUserIsLogin();
  }
  checkUserIsLogin(): any {
    const user = localStorage.getItem('user');
    if (user !== null) {
      this.redirectToVerify();
    }
  }
  redirectToVerify(): any {
    this.router.navigateByUrl('verify').then();
  }
  redirectToProfile(): any {
    if (localStorage.getItem('WhichPageComeFrom') === 'payment') {
      this.router.navigateByUrl('/pricing').then();
    } else {
      localStorage.removeItem('WhichPageComeFrom');
      this.router.navigateByUrl('/profile').then();
    }
  }
  loginUser(): any {
    this.registerSpinner = true;
    if (!this.user.username || !this.user.password) {
      if (localStorage.getItem('trans') === 'fa') {
        this.snackBar.showSnackBar(
          'فیلد ایمیل و یا شماره تلفن الزامی است.',
          'red-snackbar'
        );
      } else {
        this.snackBar.showSnackBar(
          'Email field or phone number is required',
          'red-snackbar'
        );
      }
      this.registerSpinner = false;
      return;
    } else {
      this.userService.loginWithPassword(this.user).subscribe(
        (data) => {
          localStorage.setItem('token', data);
          this.userService.getCurrentUserInfo().subscribe((dd) => {
            localStorage.setItem('userId', dd.id);
            localStorage.setItem('userProfile', dd.profile_photo_url);
            localStorage.setItem('isPremium', dd.is_premium);
            localStorage.setItem('premiumUntil', dd.premium_until);
            this.goftinoService.setGoftinoUser(dd.email, dd.name, dd.mobile);
          });
          this.registerSpinner = true;
          if (localStorage.getItem('trans') === 'fa') {
            this.snackBar.showSnackBar(
              'شما با موفقیت وارد پروفایل خود شدید.',
              'green-snackbar'
            );
          } else if (localStorage.getItem('trans') === 'en') {
            this.snackBar.showSnackBar(
              'You have been signed-in successfully.',
              'green-snackbar'
            );
          }
          this.pomodoroRepository.userIsLoggedIn = true;
          this.redirectToProfile();
        },
        (err) => {
          this.error = JSON.parse(err.error);
          if (this.pomodoroRepository.ltrDirection === true) {
            if (Object.keys(this.error)[0] === 'error') {
              this.snackBar.showSnackBar(this.error.error, 'ltr-snackbar');
            }
            if (Object.keys(this.error)[0] === 'username') {
              // tslint:disable-next-line:forin
              for (const i in this.error) {
                const child = this.error[i];
                this.snackBar.showSnackBar(child[0], 'ltr-snackbar');
                break;
              }
            }
          }
          if (this.pomodoroRepository.ltrDirection === false) {
            if (Object.keys(this.error)[0] === 'error') {
              this.snackBar.showSnackBar(this.error.error, 'red-snackbar');
            }
            if (Object.keys(this.error)[0] === 'username') {
              // tslint:disable-next-line:forin
              for (const i in this.error) {
                const child = this.error[i];
                this.snackBar.showSnackBar(child[0], 'red-snackbar');
                break;
              }
            }
          }
          this.registerSpinner = false;
        }
      );
    }
  }
  registerTest(): any {
    this.registerSpinner = true;
  }
  loginWithGoogle(): any {
    this.userService.loginGoogle().subscribe((data) => {
      window.location.href = data.url;
    });
  }
}
